module.exports = __webpack_public_path__ + "static/media/resume.688f2116.pdf";